// extracted by mini-css-extract-plugin
module.exports = {"img":"imgPrefetch_img_3gkSO","slotWrapper":"imgPrefetch_slotWrapper_3YF4Q"};